<template>
  <div>
    
    <el-row v-for="(btn, i) in btnCount" :key="i" style="background-color: #f4f4f5; padding: 8px; margin-top: 8px;">
      <el-col :xs="12" :sm="12" :md="12" class="pr-10">
        <el-form-item label="檔案備註">
          <el-input placeholder="檔案備註" v-model="fileNotes[i]" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12">
        <el-form-item label="附件">
          <el-upload
              :multiple="false"
              class="upload-demo"
              action="/api/file/upload"
              :on-success="handleUploadSuccess"
              :before-upload="beforeUpload"
              :on-remove="handleFileRemove">
            <el-button size="small" type="primary">上傳文件</el-button>
            <div slot="tip" class="el-upload__tip">限上傳 5M 以下的文件</div>
          </el-upload>
        </el-form-item>
      </el-col>
    </el-row>
    
    <el-row class="mb-20 mt-20"">
      <el-col :xs="24" :sm="24" :md="24">
        <el-button size="small" type="primary" @click="newUploadField()">新增上傳</el-button>
      </el-col>
    </el-row>

  </div>
</template>

<script>



export default {
  name: "FileUpload",
  components: {
    
  },
  props: ['fileList', 'fileNotes'],
  data() {
    return {
      
     btnCount:0,

    }
  },
  methods: {

    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      return isLt5M
    },

    newUploadField() {
      console.log('newUploadField:', this.btnCount)
      this.btnCount++
    },

    handleUploadSuccess(res, file) {
      this.fileList.push(res.uuid)
    },

    handleFileRemove(file, fileList) {
      this.fileList = this.fileList.filter(e => e !== file.response.uuid)
    },
    
  },
  mounted() {
    // console.log('fileList:', this.fileList);
    // console.log('fileNotes:', this.fileNotes);
    

  }
}
</script>

<style scoped>
.el-main {
  padding: 0;
  margin-bottom: 20px;
}
.el-card__body {
  padding: 0 12px;
}

</style>
